module.exports = __webpack_public_path__ + "static/patient2_mobile-4cbf4ee01ab7465430dee85822712786.jpg";